import { createNavigation } from 'next-intl/navigation';

const routing = {
  // Since locales are dynamic, we'll handle them at runtime
  // For now, define defaultLocale and leave locales empty
  defaultLocale: 'en',
  locales: ['en', 'fr', 'es'], // sample en because we fetch them from an API
  // Function to remove the locale from the pathname
  getPathname: (shortcode: string, pathname: string): string => {
    const segments = pathname.startsWith('/')
      ? pathname.slice(1).split('/')
      : pathname.split('/');

    if (segments[0] === shortcode) {
      segments.shift();
    }

    return '/' + segments.join('/');
  },
};

export const { Link, redirect, usePathname, useRouter } =
  createNavigation(routing);
export const getPathname = routing.getPathname;
